import { redirect } from "react-router-dom";

export const rankingRoutes = [
  {
    path: "/",
    lazy: () =>
      import("../../modules/ranking/global-ranking").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/ranking",
    lazy: () =>
      import("../../modules/ranking/global-ranking").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/ranking/global",
    loader: async () => redirect("/ranking"),
  },
  {
    path: "/ranking/trending",
    lazy: () =>
      import("../../modules/ranking/trending/").then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: "/ranking/movies",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/movies/GRMovies"
      ).then((m) => ({ Component: m.GRMovies })),
  },
  {
    path: "/ranking/games",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/gaming/GRGaming"
      ).then((m) => ({ Component: m.GRGaming })),
  },
  {
    path: "/ranking/series",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/series/GRSeries"
      ).then((m) => ({ Component: m.GRSeries })),
  },
  {
    path: "/ranking/series-originals",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/series-originals/GRSeriesOriginals"
      ).then((m) => ({ Component: m.GRSeriesOriginals })),
  },
  {
    path: "/ranking/franchises",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/franchises/GRFranchises"
      ).then((m) => ({ Component: m.GRFranchises })),
  },
  {
    path: "/ranking/books",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/books/GRBooks"
      ).then((m) => ({ Component: m.GRBooks })),
  },
  {
    path: "/ranking/anime",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/anime/GRAnime"
      ).then((m) => ({ Component: m.GRAnime })),
  },
  {
    path: "/ranking/manga",
    lazy: () =>
      import(
        "../../modules/ranking/global-ranking/pantheon-ranking/pages/manga/GRManga"
      ).then((m) => ({ Component: m.GRManga })),
  },
  {
    path: "/ranking/by-collection",
    lazy: () =>
      import("../../modules/ranking/tracked-ranking/").then((m) => ({
        Component: m.TrackedRankingIndex,
      })),
  },
  {
    path: "/ranking/global/datatable",
    lazy: () =>
      import("../../modules/ranking/global-ranking/raw-data/").then((m) => ({
        Component: m.default,
      })),
  },
  // Legacy redirects
  {
    path: "/dashboards/globalranking/movies",
    loader: async () => redirect("/ranking/movies"),
  },
  {
    path: "/dashboards/globalranking/gaming",
    loader: async () => redirect("/ranking/games"),
  },
  {
    path: "/dashboards/globalranking/series",
    loader: async () => redirect("/ranking/series"),
  },
  {
    path: "/dashboards/raw-data",
    loader: async () => redirect("/ranking/by-collection"),
  },
];
